/**
 * Ajánlati dokumentumokban használható kulcsok
 * Ezek a kulcsok helyettesítődnek a tényleges értékekkel a dokumentum generálásakor
 */
export const quotationKeys = {
  // Alapvető árajánlat adatok
  'Ajánlat száma': '',
  'Cég megnevezése': '',
  'Cég címe': '',
  'Adószám': '',
  'Cégjegyzékszám': '',
  'Képviselő neve': '',
  'Kapcsolattartó neve': '',
  'Dátum': '',
  'Ajánlat érvényessége': '',
  'Fizetési határidő': '',
  
  // Termék táblázat és összesítés
  'TERMÉKEK_TÁBLÁZAT': '',
  'Részösszeg': '',
  'ÁFA összeg': '',
  'Végösszeg': '',
  'Valuta': '',
  
  // Megjegyzések
  'Megjegyzések': '',
  
  // Ügyfél adatok
  'Ügyfél neve': '',
  'Ügyfél címe': '',
  'Ügyfél adószáma': '',
  'Ügyfél email': '',
  'Ügyfél telefon': '',
  
  // Szervezet adatok
  'Szervezet neve': '',
  'Szervezet címe': '',
  'Szervezet adószáma': '',
  'Szervezet cégjegyzékszáma': '',
  'Szervezet email': '',
  'Szervezet telefon': '',
  
  // Dátumok
  'Létrehozás dátuma': '',
  'Módosítás dátuma': '',
  'Érvényesség kezdete': '',
  'Érvényesség vége': '',
  
  // Státusz
  'Státusz': '',
  'Státusz magyar': ''
};

